import _ from "lodash";

export function formatCurrency (currency, digits = undefined) {
  if (typeof(digits) === "undefined") {
    digits = 2;
  }

  const formatter = new Intl.NumberFormat("en", {currency: "USD", style: "currency"});
  const formattedAmount = formatter.format(currency);
  
  return `${formattedAmount}`;
}

export function roundCurrencyUSD(amount) {
  return Math.round(100 * amount) / 100.0;
}
